/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OrganizationMcpServer,
  OrganizationMcpServer$inboundSchema,
} from "./organizationmcpserver.js";

/**
 * Result type for the MCP servers attached to a remote_session_client.
 */
export type ListOrganizationMcpServersResult = {
  items: Array<OrganizationMcpServer>;
};

/** @internal */
export const ListOrganizationMcpServersResult$inboundSchema: z.ZodMiniType<
  ListOrganizationMcpServersResult,
  unknown
> = z.object({
  items: z.array(OrganizationMcpServer$inboundSchema),
});

export function listOrganizationMcpServersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListOrganizationMcpServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListOrganizationMcpServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListOrganizationMcpServersResult' from JSON`,
  );
}
